module.exports = __webpack_public_path__ + "img/pretzel.735a8e42.svg";